// import Vue from 'vue'
import consts from "@/consts"
import range from "lodash/range";
import {getApiProps, updateObjectByDiff} from "@/lib/lib";
// import {arraySplitIntoChunks} from "@/lib/lib";
// import {objectComparison} from "@/lib/lib";
const changedField = 'changed__time';

const collator = new Intl.Collator();
const sortByName = function (a, b) {
    let cmp = collator.compare(a?.name_ || '', b?.name_ || '')
    if (cmp) {
        return cmp;
    }
    return a.id - b.id;
}

export default {
    state: {
        driversGroupsLiteLoad: false,
        driversGroupsFullLoad: false,
        driversGroups: [],
    },
    actions: {
        fetchDriversGroups/*all*/({dispatch, getters}, args) {
            return new Promise((resolve, reject) => {
                if (!getters.getApiToken) {
                    return reject(false)
                }
                dispatch('setLastCall', {name: 'fetchDriversGroups', args, time: Date.now() / 1000})

                const params = getApiProps('drivers_groups', args)
                this.$api.driversGroups.getAll({...params})
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error) {
                            resolve(response.data)
                        } else {
                            reject(response)
                        }
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error);
                    })
                    .finally(() => {
                        dispatch('setLastCall', {name: 'fetchDriversGroups', args, inprogress: false})
                    });
            })
        },
        fetchDriversGroupsAll({dispatch, commit}) {
            return new Promise((resolve, reject) => {
                this.$api.init.getDriversGroups()
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error) {

                            commit('setDriversGroups', response.data)
                            commit('setDriversGroupsLiteLoad', true)

                            resolve(true)
                        } else {
                            reject(response)
                        }
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error);
                        setTimeout(() => {
                            dispatch('fetchDriversGroupsAll', {})
                        }, 60 * 1000)
                    })
            })
        },
        fetchDriversGroupsAllLite({dispatch, commit, getters}) {
            return new Promise((resolve, reject) => {
                if (getters.isDriversGroupsLiteLoad) {
                    return resolve(getters.getDriversGroups.length)
                }
                dispatch('fetchDriversGroups', {lite: true})
                    .then((data) => {
                        commit('updateDriversGroups', data)
                        commit('setDriversGroupsLiteLoad', true)
                        resolve(data.length)
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error);
                        setTimeout(() => {
                            dispatch('fetchDriversGroupsAllLite', {})
                        }, 60 * 1000)
                    })
            })
        },
        fetchDriversGroupsAllPages({dispatch, commit, getters}, args) {
            //dispatch('setLastCall', {name: 'fetchDriversGroupsAll', args, time: Date.now() / 1000})
            dispatch('setLastCall', {name: 'fetchDriversGroupsChanged', args, time: Date.now() / 1000})

            return new Promise((resolve, reject) => {
                    if (!getters.getApiToken) {
                        return reject(null)
                    }
                    if (!getters.getDriversGroups.length) {
                        return resolve([])
                    }
                    let pageSize = consts.querySettings.pageSize
                    let pages = Math.ceil(getters.getDriversGroups.length / pageSize)
                    let fetch = range(pages).map(i => {
                        let page = i + 1;
                        return dispatch('fetchDriversGroups', {page, 'page-size': pageSize, ...args})
                            .then((data) => {
                                commit('updateDriversGroups', data)
                            })
                            .catch(() => {
                                dispatch('fetchDriversGroups', {page, 'page-size': pageSize, ...args})
                            })
                    });
                    resolve(fetch)
                })
                .then((fetch) => {
                    return Promise.all(fetch)
                        .finally(() => {
                            commit('setDriversGroupsFullLoad', true)
                        })
                })
                .finally(() => {
                    //dispatch('setLastCall', {name: 'fetchDriversGroupsAll', args, inprogress: false})
                    dispatch('setLastCall', {name: 'fetchDriversGroupsChanged', args, inprogress: false})
                })
        },
        fetchDriversGroupsChanged({dispatch, commit, getters}, args) {
            if (!getters.getApiToken || !getters.isDriversGroupsFullLoad) {
                return Promise.resolve(null)
            }
            dispatch('setLastCall', {name: 'fetchDriversGroupsChanged', args, time: Date.now() / 1000})

            args = {...consts.querySettings.filter, ...args}
            return dispatch('fetchDriversGroups', args)
                .then((data) => {
                    commit('updateDriversGroups', data)
                    return dispatch('fetchDriversGroups', {fields: 'id', expand: ''})
                })
                .then((data) => {
                    commit('filterDriversGroups', data)
                })
                .finally(() => {
                    dispatch('setLastCall', {name: 'fetchDriversGroupsChanged', args, inprogress: false})
                });
        },
        fetchFavoritesDriversGroups({dispatch, commit, getters}, args) {
            return new Promise((resolve, reject) => {
                if (!getters.getApiToken) {
                    return reject(false)
                }
                dispatch('setLastCall', {name: 'fetchFavoritesDriversGroups', args, time: Date.now() / 1000})

                dispatch('fetchDriversGroups', {filter: {favorites: true}})
                    .then((data) => {
                        commit('updateDriversGroups', data)
                        resolve(true)
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error);
                    })
                    .finally(() => {
                        dispatch('setLastCall', {name: 'fetchFavoritesDriversGroups', args, inprogress: false})
                    });
            })
        },
        reloadDriversGroupsAll({commit, dispatch}, args) {
            commit('clearDriversGroups')
            return dispatch('fetchDriversGroupsAllLite', args)
                .then(() => {
                    dispatch('fetchDriversGroupsAllPages', args)
                })
        },

        saveDriversGroup({dispatch}, driversGroup) {
            let fn = (driversGroup.id) ? 'updateDriversGroup' : 'createDriversGroup'
            return dispatch(fn, driversGroup);
        },
        createDriversGroup({commit, dispatch}, driversGroup) {
            return new Promise((resolve, reject) => {
                const params = getApiProps('drivers_groups')
                this.$api.driversGroups.create(driversGroup, params)
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error) {
                            commit('updateDriversGroup', response.data)
                            dispatch('fetchDriversGroupsChanged')
                        }
                        resolve(response)
                    })
                    .catch((error) => {
                        console.error(error);
                        reject(error)
                    });
            })
        },
        updateDriversGroup({commit, dispatch}, driversGroup) {
            return new Promise((resolve, reject) => {
                const params = getApiProps('drivers_groups')
                this.$api.driversGroups.update(driversGroup.id, driversGroup, params)
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error) {
                            commit('updateDriversGroup', response.data)
                            dispatch('fetchDriversGroupsChanged')
                        }
                        resolve(response)
                    })
                    .catch((error) => {
                        console.error(error);
                        reject(error)
                    });
            })
        },
        deleteDriversGroup({commit, dispatch}, id) {
            return new Promise((resolve, reject) => {
                const params = getApiProps('drivers_groups')
                this.$api.driversGroups.delete(id, {...params})
                    .then((response) => {
                        if (response.status < 400 && (!response.data || !response.data?.error)) {
                            commit('deleteDriversGroup', id)
                            dispatch('fetchDriversGroupsChanged')
                        }
                        resolve(response)
                    })
                    .catch((error) => {
                        console.error(error);
                        reject(error)
                    });
            })
        },

    },
    mutations: {
        setDriversGroupsLiteLoad(state, LiteLoad) {
            state.driversGroupsLiteLoad = state.driversGroupsLiteLoad || LiteLoad
        },
        setDriversGroupsFullLoad(state, FullLoad) {
            state.driversGroupsFullLoad = state.driversGroupsFullLoad || FullLoad
        },

        setDriversGroups(state, nDriversGroups) {
            nDriversGroups = nDriversGroups.map(u => {
                if (u?.name) u.name_ = u.name.toLocaleLowerCase()
                return u //Object.freeze(u)
            })
            nDriversGroups.sort(sortByName)
            state.driversGroups = nDriversGroups
        },

        updateDriversGroups(state, nDriversGroups) {
            if (!state.driversGroups.length) {
                nDriversGroups = nDriversGroups.map(u => {
                    if (u?.name) u.name_ = u.name.toLocaleLowerCase()
                    return u //Object.freeze(u)
                })
                nDriversGroups.sort(sortByName)
                state.driversGroups = nDriversGroups
                // const chunks = arraySplitIntoChunks(nDriversGroups)//.reverse();
                // const pushOnRenderTask = () => {
                //     if (chunks.length === 0) return;
                //     let chunk = chunks.pop();
                //     state.driversGroups.push(...chunk);
                //     setTimeout(() => {
                //     requestAnimationFrame(pushOnRenderTask);
                //     }, 300)
                //     //this.$nextTick().then(() => pushOnRenderTask())
                // }
                // pushOnRenderTask();
                return true
            }

            nDriversGroups.forEach(function (nDriversGroup) {
                if (nDriversGroup?.name) nDriversGroup.name_ = nDriversGroup.name.toLocaleLowerCase()
                let i = state.driversGroups.findIndex(u => (u.id == nDriversGroup.id))
                if (i < 0) {
                    state.driversGroups.push(nDriversGroup) //(Object.freeze(nDriversGroup))
                } else
                if (!state.driversGroupsFullLoad || state.driversGroups[i][changedField] != nDriversGroup[changedField]) {
                    updateObjectByDiff(state.driversGroups[i], nDriversGroup)
                    // delete nDriver.id
                    // nDriversGroup = {...state.driversGroups[i], ...nDriversGroup}
                    // state.driversGroups[i] = nDriversGroup //Object.freeze(nDriversGroup)
                }
            })
        },
        filterDriversGroups(state, nDriversGroups) {
            // let Ids = state.driversGroups.map(u=> u.id)
            let nIds = nDriversGroups.map(u => u.id)
            let removedIds = state.driversGroups.filter(u => !nIds.includes(u.id)).map(u => u.id)
            removedIds.forEach(removedId => {
                let i = state.driversGroups.findIndex(u => (u.id == removedId))
                if (i != -1) {
                    state.driversGroups.splice(i, 1)
                }
            })
        },
        updateDriversGroup(state, nDriversGroup) {
            if (nDriversGroup?.name) nDriversGroup.name_ = nDriversGroup.name.toLocaleLowerCase()
            let i = state.driversGroups.findIndex(u => (u.id == nDriversGroup.id))
            if (i < 0) {
                state.driversGroups.push(nDriversGroup) //(Object.freeze(nDriversGroup))
            } else
            if (!state.driversGroupsFullLoad || state.driversGroups[i][changedField] != nDriversGroup[changedField]) {
                updateObjectByDiff(state.driversGroups[i], nDriversGroup)
                // delete nDriver.id
                // nDriversGroup = {...state.driversGroups[i], ...nDriversGroup}
                // state.driversGroups[i] = nDriversGroup //Object.freeze(nDriversGroup)
            }
        },

        deleteDriversGroup(state, id) {
            let i = state.driversGroups.findIndex(u => (u.id == id))
            if (i != -1) {
                state.driversGroups.splice(i, 1)
            }
        },

        clearDriversGroups(state) {
            state.driversGroups = []
            state.driversGroupsLiteLoad = false
            state.driversGroupsFullLoad = false
        },
    },
    getters: {
        isDriversGroupsLiteLoad(state) {
            return state.driversGroupsLiteLoad
        },
        isDriversGroupsFullLoad(state) {
            return state.driversGroupsFullLoad
        },
        getDriversGroups(state, getters) {
            let driversIds = getters.getDrivers?.map(u => u.id) || []
            return state.driversGroups
                .map(g => {
                    let color = g.color || consts.driversGroupsColors[0]
                    return {...g, color, drivers: g.drivers.filter(uid => driversIds.includes(uid))}
                })
        },
        getDriversGroupsIds(state) {
            return state.driversGroups.map(g => g.id)
        },
        getDriversGroupsByIds(_, getters) {
            return getters.getDriversGroups.reduce((driversGroupsByIds, g) => {
                driversGroupsByIds[g.id] = g
                return driversGroupsByIds
            }, {})
        },
        getSortedDriversGroupsIds(state) {
            let driversGroups = state.driversGroups
            driversGroups.sort(sortByName)
            return driversGroups.map(u => u.id)
        },
    }
}
